import React, { useState } from "react";
import { withStyles } from "@mui/styles";
import { styleSheet } from "./style.js";
import { styled, alpha } from "@mui/material/styles";
import { Box, Button, Typography, InputBase, IconButton } from "@mui/material";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import { getDocUrl } from "../../../../../redux/docs/getDocUrl";
import useDocumentDownloader from "../../../../../customHooks/useDocumentDownloader";

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    // vertical padding + font size from searchIcon
    padding: "0 10px 0 10px ",
    width: "250px",
    height: "35px",
    transition: theme.transitions.create("width"),
    border: "1px solid rgba(0, 0, 0, 0.23)",
    borderRadius: "25px",
    color: "rgba(0, 0, 0, 0.6)",
    letterSpacing: "0.15px",
    [theme.breakpoints.up("sm")]: {
      "&:focus": {},
    },
  },
}));
const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginLeft: 0,

  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(1),
    width: "auto",
  },
}));

const HeaderDocs = ({
  classes,
  addFolderModal,
  setOpenEditMls,
  handleSearchInputChange,
  selectedCheckboxIds,
  actionOptions,
  setOpenRename,
  setFolderDetails,
  docsData,
  setOpenDetail,
}) => {
  console.log(selectedCheckboxIds);
  const { downloadDocuments, isDownloading } = useDocumentDownloader();

  const handleDownload = () => {
    downloadDocuments(selectedCheckboxIds, {
      getDocUrlAction: getDocUrl,
    });
  };

  return (
    <Box
      className={classes.docsAppBar}
      sx={{ position: "sticky", top: "64px", zIndex: "100" }}
    >
      <Box
        sx={{ padding: "0px 20px !important" }}
        className={classes.docsAppBarArea}
      >
        <Box className={classes.docsTitle}>My Docs</Box>
        <Box className={classes.docsAppBarRight}>
          {selectedCheckboxIds?.length > 0 ? (
            <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
              {actionOptions?.map((item, index) => {
                const Icon = item.icon;
                if (
                  selectedCheckboxIds?.length > 1 &&
                  item.value === "rename"
                ) {
                  return null;
                }
                if (selectedCheckboxIds?.length > 1 && item.value === "info") {
                  return null;
                }
                return (
                  <IconButton
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "column",
                      alignItems: "center",
                      gap: "0px",
                      borderRadius: "0px",
                    }}
                    onClick={() => {
                      if (item.label === "Edit MLS #") {
                        setOpenEditMls(true);
                      } else if (item.label === "Download") {
                        handleDownload();
                      } else if (item.label === "Rename") {
                        setOpenRename(true);
                        setFolderDetails(
                          docsData?.find(
                            (doc) => doc.id === selectedCheckboxIds[0]
                          )
                        );
                      } else if (item.label === "Info") {
                        setFolderDetails(
                          docsData?.find(
                            (doc) => doc.id === selectedCheckboxIds[0]
                          )
                        );
                        setOpenDetail(true);
                      }
                    }}
                  >
                    {item.type === "img" ? (
                      <img
                        style={{ objectFit: "contain" }}
                        src={item.icon}
                        alt={item.label}
                        width={23}
                        height={23}
                      />
                    ) : (
                      <Icon sx={{ fontSize: "17px" }} />
                    )}
                    <Typography sx={{ fontSize: "12px" }}>
                      {item.label}
                    </Typography>
                  </IconButton>
                );
              })}
            </Box>
          ) : null}

          <Button
            size="small"
            variant="contained"
            endIcon={<AddRoundedIcon sx={{ fontSize: "15px" }} />}
            classes={{ root: classes.newfolderButton }}
            onClick={addFolderModal}
          >
            New Folder
          </Button>
          <Search>
            <StyledInputBase
              placeholder="Search Folders"
              inputProps={{ "aria-label": "search" }}
              onChange={(e) => handleSearchInputChange(e)}
            />
          </Search>
        </Box>
      </Box>
    </Box>
  );
};

export default withStyles(styleSheet, { name: "HeaderFolderStyle" })(
  HeaderDocs
);
